'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', '$uibModalInstance', 'certs',
    function ($scope, $modalInstance, certs) {

        $scope.certs = certs;
        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.selectedCert = null;
        $scope.selectCertificate = function(certificate) {
            $scope.selectedCert = certificate;
        }
        $scope.isSelectedCert = function isSelectedCert(item) {
            if (!$scope.selectedCert) return false;
            return $scope.selectedCert.thumbprint === item.thumbprint;
        }

        function ok() {
            $modalInstance.close($scope.selectedCert);
        }

        function cancel() {
            $modalInstance.dismiss();
        }
    }];
